// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MetaverseHealthPage/MetaverseHealthPage.css
// module id = 958
// module chunks = 0